import { AppAreaConfig } from '@/funnels/@types'
import walkingMale from './activity-male-walking'
import walkingLymphaticFemale from './activity-female-lymphatic-walking'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-lymphatic-walking',
	landing: {
		ids: ['loader-lymphatic-walking', 'age-lymphatic-walking'],
		route: {
			path: '/lymphatic-walking',
			name: 'main-lymphatic-walking-funnel',
		},
	},
	funnel: {
		id: 'ob-lymphatic-walking-gender-selection',
		route: {
			path: '/lymphatic-walking/ob/:page(.*)?',
			name: 'main-lymphatic-walking',
		},
		slug: 'main-lymphatic-walking',
		locale: ['en'],
		redirectTo: {
			sex: {
				male: { appArea: walkingMale },
				female: { appArea: walkingLymphaticFemale },
			},
		},
	},
}

export default appAreaConfig
